module.exports = function getResource(label) {
    let resources = {
        saveToMyAccountCheckbox: 'Save to my account'
    };

    return resources[label];
};
